const PRESET_ICONS = [
  "ri-question-line",
  "ri-volume-up-line",
  "ri-headphone-line",
  "ri-stethoscope-line",
  "ri-heart-pulse-line",
  "ri-parent-line",
  "ri-money-cny-circle-line",
  "ri-first-aid-kit-line",
  "ri-mic-line",
  "ri-sound-module-line",
  "ri-pulse-line",
  "ri-shield-check-line",
  "ri-hospital-line",
  "ri-user-heart-line",
  "ri-customer-service-2-line",
  "ri-calendar-check-line",
];

type AdminIconPickerProps = {
  value: string;
  onChange: (icon: string) => void;
};

export function AdminIconPicker({ value, onChange }: AdminIconPickerProps) {
  return (
    <div className="grid gap-2">
      <div className="grid grid-cols-8 gap-2 rounded-md border border-[#cfd8d2] bg-white p-2 sm:grid-cols-8">
        {PRESET_ICONS.map((icon) => (
          <button
            key={icon}
            type="button"
            title={icon}
            onClick={() => onChange(icon)}
            className={`flex h-10 items-center justify-center rounded-md border text-lg transition ${
              value === icon ? "border-[#315746] bg-[#315746] text-white" : "border-[#e2e8e5] bg-white text-[#315746] hover:bg-[#f0f5f2]"
            }`}
          >
            <i className={icon} />
          </button>
        ))}
      </div>
      <input
        className="h-11 rounded-md border border-[#cfd8d2] px-3 font-mono text-sm outline-none focus:border-[#315746] focus:ring-2 focus:ring-[#315746]/15"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="ri-question-line"
      />
      <p className="text-xs leading-5 text-[#7b877f]">
        點選上方圖示快速套用，或直接輸入 Remix Icon class 名稱（參考 remixicon.com）。
      </p>
    </div>
  );
}
